export default "__VITE_ASSET__DGkiqV53__"